import { Button, Tooltip } from '@mui/material'
import { Icon } from 'components'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface QuestionButtonProps {
  visible?: boolean
  onClick?: () => void
}

export const QuestionButton = (props: QuestionButtonProps) => {
  const { visible, onClick } = props
  const { t } = useTranslation();
  return (
    <>
      {visible ? (
        <Tooltip placement='left' title={t('statistic_help_fab')}>
          <Button
            startIcon = {<Icon size='size-18' iconId='info' />}
            variant   = 'text'
            color     = 'secondary'
            onClick   = {onClick}
          >
            {t('walkthrough')}
          </Button>
        </Tooltip>
      ) : null}
    </>
  )
}
